import { Icd10Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';
import { MedicalCertificateParameters } from '@dreryk/egabinet-visit-frontend-api';

import { MedicalCertificateFormBean } from './MedicalCertificateForm.types';

type MedicalCertificateFormPayload = {
   medicalCertificateParameters: MedicalCertificateParameters;
};

export const createMedicalCertificateFormPayload = (
   bean: MedicalCertificateFormBean
): MedicalCertificateFormPayload => {
   const medicalCertificateParameters = new MedicalCertificateParameters();
   medicalCertificateParameters.content = bean.certificateDetails!;
   medicalCertificateParameters.diagnoses = bean.diagnoses.value?.map((diagnosis) => {
      return {
         diseaseIcd10Code: Icd10Code.of(diagnosis.code),
         main: diagnosis.main,
         leftSide: diagnosis.bodySide.left,
         rightSide: diagnosis.bodySide.right,
      };
   });

   return {
      medicalCertificateParameters: medicalCertificateParameters,
   };
};
